export default __webpack_public_path__ + "static/media/iconly_bulk_profile.258ae932.svg";